import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ChargedActAcceptDialogComponent} from './charged-act-accept-dialog.component';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {ReactiveFormsModule} from '@angular/forms';
import {ViewByIdDefaultModule} from '../../../../../core/component/view-by-id-default/view-by-id-default.module';
import {CardModule} from '../../../../../core/component/card/card.module';
import {DatePickerModule} from '../../../../../../components/common/date-picker/date-picker.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {
    UserSelectFilterModule
} from '../../../../../account/modules/user/api/component/user-select-filter/user-select-filter.module';
import {
    SaleProductsCardModule
} from "../../../../../sale/modules/product/api/component/sale-product-card/sale-products.card.module";
import {RichTextEditorModule} from "../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {AmountInputModule} from "../../../../../../components/common/amount/amount-input/amount-input.module";
import {
    SaleSavePaymentRequestsFormModule
} from "../../../../../sale/api/component/sale-save-payment-requests-form/sale-save-payment-requests-form.module";
import {ActionDefaultPagePageModule} from "../../../../../core/page/action-default-page/action-default-page.module";
import {ActionDefaultModule} from '../../../../../core/component/action-default/action-default.module';
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {ActionButtonModule} from "../../../../../core/component/action-button/action-button.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DialogModule,
        ReactiveFormsModule,
        ViewByIdDefaultModule,
        CardModule,
        DatePickerModule,
        FormFieldModule,
        InputTextModule,
        UserSelectFilterModule,
        SaleProductsCardModule,
        RichTextEditorModule,
        AmountInputModule,
        SaleSavePaymentRequestsFormModule,
        ActionDefaultPagePageModule,
        ActionDefaultModule,
        CardV2Component,
        ButtonModule,
        ActionButtonModule
    ],
    declarations: [ChargedActAcceptDialogComponent],
    exports: [
        ChargedActAcceptDialogComponent
    ]
})
export class ChargedActAcceptDialogModule {
}
